export const PSZX_LIST = [{
  key: 'km',
  label: '昆配'
},
{
  key: 'dl',
  label: '大配'
},
{
  key: 'zt',
  label: '昭配'
},
{
  key: 'cx',
  label: '楚配'
},
{
  key: 'hh',
  label: '红配'
},
{
  key: 'qj',
  label: '曲配'
},
{
  key: 'yx',
  label: '玉配'
}]

export const PASS_LIST = [{
  label: '一环通行证',
  key: '90'
},
{
  label: '二环通行证',
  key: '50'
},
{
  label: '三环通行证',
  key: '10'
},
{
  label: '无',
  key: '0'
}]

export const AXLE_LIST = [{
  label: '2',
  key: '2'
},
{
  label: '3',
  key: '3'
},
{
  label: '4',
  key: '4'
},
{
  label: '5',
  key: '5'
},
{
  label: '6',
  key: '6'
},
{
  label: '无',
  key: '0'
}]

export const GASG_STATUS = [{
  label: '开启',
  key: '开启'
},
{
  label: '维护',
  key: '维护'
},
{
  label: '关闭',
  key: '关闭'
}]

export const OIL_TYPES = ['90号汽油(Ⅲ)', '92号车用汽油(Ⅴ)', '93号汽油(Ⅲ)', '93号车用汽油(Ⅳ)', '95号车用汽油(Ⅴ)', '97号汽油(Ⅲ)', '97号车用汽油(Ⅳ)', '98号车用汽油(Ⅴ)', '0号普通柴油', '0号柴油', '0号车用柴油(Ⅲ)', '0号车用柴油(Ⅴ)', '0号车用柴油(Ⅳ)', '1号煤油(旧)', '国二号标准汽油90#', '国二号标准汽油93#', '国二号标准汽油97#']



// WEBPACK FOOTER //
// ./src/api/static_data.js